import { api } from "@/builders/axios";

const get = function () {
  return api.get("/school-guide");
};

export const school_guide = {
  get,
};
